import { Component, Input } from '@angular/core';
import { CountryItem, TravelItemMinimal } from '../../../api/models';
import { startOfToday, subDays, isWithinInterval } from 'date-fns';
import { Router } from '@angular/router';
import { CountryService } from '../../../api/services';
import { SlugifyPipe } from '../../pipes/slugify.pipe';
import { enumAssignmentStatus } from '../../utils/enum-assignment-request';

@Component({
  selector: 'app-travel-card',
  templateUrl: './travel-card.component.html',
  styleUrl: './travel-card.component.scss',
})
export class TravelCardComponent {
  @Input() travel!: TravelItemMinimal;
  @Input() country?: CountryItem;
  @Input() fromFavs?: boolean;
  @Input() show_organization?: boolean;
  dates: string[] = [];
  strippedString = '';
  enumAssignmentStatus = enumAssignmentStatus;
  cheapestPackagePrice?: number;

  constructor(
    private router: Router,
    private countryService: CountryService,
    private slugifyPipe: SlugifyPipe
  ) {}

  ngOnInit() {
    this.dates.push(this.travel.from_date);
    this.dates.push(this.travel.to_date);

    this.strippedString = this.sanitizeContent(this.travel.summary);

    //PRICE
    if (this.travel?.price_packages && this.travel?.price_packages.length > 0) {
      const prices = this.travel.price_packages.map((p) => p.price_per_person);
      this.cheapestPackagePrice = Math.min(...prices);
    }
  }

  sanitizeContent(content: string): string {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    const decodedText = doc.body.innerHTML.replace(/&nbsp;/g, ' ');
    return decodedText.replace(/(<([^>]+)>)/gi, '').trim();
  }

  checkDatesForAlert(travel: TravelItemMinimal): boolean {
    const d = new Date(travel.from_date);
    return this.isTodayWithinRange(d);
  }

  isTodayWithinRange(depDate: Date): boolean {
    const today = startOfToday();
    const endDate = subDays(depDate, 14); // Sottrae 14 giorni da depDate
    const interval = { start: endDate, end: depDate };

    return isWithinInterval(today, interval);
  }

  checkForAvailability(travel: TravelItemMinimal) {
    const maxMembers = travel.max_members;
    const currentMembers = 4;
    return this.isGreaterThanPercentage(maxMembers, currentMembers, 70);
  }

  isGreaterThanPercentage(X: number, Y: number, percentage: number): boolean {
    if (X > Y) {
      const threshold = X * (percentage / 100);
      return Y > threshold;
    } else {
      return false;
    }
  }

  goTo() {
    const slugifyName = this.slugifyPipe.transform(this.travel.name);

    // if(this.fromFavs === true){ //se provengo dalla pagina dei miei preferiti
    //   this.router.navigate(['/travels', 'my-favs', this.travel.id, slugifyName]);
    // }
    // else if(this.country){ //se provengo dalla travel list di un country specifico
    //   this.router.navigate(['/travels', this.country.ISO, this.country.name,  this.travel.id, slugifyName])
    // }
    // else{
    //   this.router.navigate(['/travels', this.travel.countries[0].country.ISO, this.travel.countries[0].country.name, this.travel.id, slugifyName]);
    // }

    if (this.country) {
      this.router.navigate([
        '/viaggi-di-gruppo',
        this.country.ISO,
        this.country.name,
        this.travel.id,
        slugifyName,
      ]);
    } else {
      this.router.navigate([
        '/viaggi-di-gruppo',
        this.travel.countries[0].country.ISO,
        this.travel.countries[0].country.name,
        this.travel.id,
        slugifyName,
      ]);
    }
  }
}
